import { createReducer } from '@reduxjs/toolkit';

import {
  emailsError,
  emailsHydrateFromTemplate,
  emailsRequest,
  emailsSendStore,
  emailsStore,
  emailsUpdateBackdropColor,
  emailsUpdateBackgourndColor,
  emailsUpdateBlocks,
  emailsUpdateFont,
  emailsUpdateReplyToAddress,
  emailsUpdateSenderName,
  emailsUpdateSubject,
  emailsUpdateTextColor,
  emailsUpdateTitle,
} from './emailsActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  templateId: null,
  blocks: [],
  title: 'Untitled',
  footer: {},
  design: {},
  backgroundColor: '#ffffff',
  backdropColor: '#ffffff',
  textColor: '#000000',
  font: 'Open Sans',

  fromName: '',
  subject: '',
  previewLine: '',

  replyToAddress: '',
  senderName: '',
  contentType: 'styled',
  plainContent: '',
  isTemplate: false,
};

const emails = createReducer(initialState, (builder) => {
  builder
    .addCase(emailsRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(emailsError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(emailsStore, (state, { payload: { emails, isTemplate } }) => {
      const { id, name, templateId, blocks, footer, design, contentType, plainContent, subject } = emails;

      return {
        ...state,
        id,
        templateId: isTemplate ? id : templateId,
        blocks,
        title: isTemplate ? name : name,
        subject: subject ?? '',
        error: null,
        requesting: false,
        footer,
        design,
        backgroundColor: design?.backgroundColor ?? '#ffffff',
        backdropColor: design?.backdropColor ?? '#ffffff',
        textColor: design?.textColor ?? '#000000',
        font: design?.font ?? 'Open Sans',
        contentType: contentType ?? 'styled',
        plainContent,
        isTemplate,
      };
    })

    // Hydrate the editor store from GetEmailTemplateEx (id === templateId) on a direct
    // load / refresh, when the store was never populated via the list click flow.
    .addCase(emailsHydrateFromTemplate, (state, { payload: emails }) => {
      const { id, name, blocks, footer, design, contentType, plainContent, subject } = emails;

      return {
        ...state,
        id,
        templateId: id,
        blocks: blocks ?? [],
        title: name ?? state.title,
        subject: subject ?? state.subject,
        error: null,
        requesting: false,
        footer,
        design,
        backgroundColor: design?.backgroundColor ?? state.backgroundColor,
        backdropColor: design?.backdropColor ?? state.backdropColor,
        textColor: design?.textColor ?? state.textColor,
        font: design?.font ?? state.font,
        contentType: contentType ?? state.contentType,
        plainContent: plainContent ?? state.plainContent,
      };
    })

    .addCase(emailsSendStore, (state, { payload }) => {
      console.log('payload', payload);
      const { previewLine, fromName, subject } = payload;

      return {
        ...state,
        previewLine,
        fromName,
        subject: subject ?? state.subject,
      };
    })

    .addCase(emailsUpdateBlocks, (state, { payload: blocks }) => ({ ...state, blocks }))
    .addCase(emailsUpdateTitle, (state, { payload: title }) => ({ ...state, title }))
    .addCase(emailsUpdateSubject, (state, { payload: subject }) => ({ ...state, subject }))

    .addCase(emailsUpdateBackgourndColor, (state, { payload: backgroundColor }) => ({ ...state, backgroundColor }))
    .addCase(emailsUpdateBackdropColor, (state, { payload: backdropColor }) => ({ ...state, backdropColor }))
    .addCase(emailsUpdateTextColor, (state, { payload: textColor }) => ({ ...state, textColor }))
    .addCase(emailsUpdateFont, (state, { payload: font }) => ({ ...state, font }))

    .addCase(emailsUpdateReplyToAddress, (state, { payload: replyToAddress }) => ({ ...state, replyToAddress }))
    .addCase(emailsUpdateSenderName, (state, { payload: senderName }) => ({ ...state, senderName }));

  // .addCase(emailsUpdateFooter, (state, { payload: footer }) => ({ ...state, footer }))
});

export default emails;
